import React, { useContext } from "react";
import TablePlaceholder from "../../Utils/TablePlaceholder";
import "../../stylesheet/activities.css";
import { useNavigate } from "react-router-dom";
import PatientReport from "./PatientReport";
import PatientContext from "../../context/patientContext";


const PatientActivities = ({ notify }) => {
  const navigate = useNavigate()

  const { allPatients } = useContext(PatientContext)

  return (
    <PatientContext.Provider value={allPatients}>
      <div className="activities">
        <div className="header_act">
          <h2>Recent Activities</h2>
          <button onClick={() => {
            navigate('/patients/patient-report')
          }}>
            <p>View All</p>
          </button>
        </div>
        <div className="relative">
          {
            allPatients.length > 0
              ?
              <div className="px-8 py-3" >
                <PatientReport maxList={5} noTopnav={true} />
              </div>
              : <TablePlaceholder lost="You have no previous patients, create a new patient through the Patients manager dropdown.
           Go to Patients manager Add new patient."/>
          }

        </div>

      </div>
    </PatientContext.Provider>
  );
};

export default PatientActivities;
